"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientConsentCallback = exports.ConsentEvent = void 0;
var tslib_1 = require("tslib");
var ConsentEvent = /** @class */ (function (_super) {
    tslib_1.__extends(ConsentEvent, _super);
    function ConsentEvent(detail) {
        return _super.call(this, ConsentEvent.EVENT_NAME, { detail: detail }) || this;
    }
    ConsentEvent.EVENT_NAME = 'consent_updated';
    return ConsentEvent;
}(CustomEvent));
exports.ConsentEvent = ConsentEvent;
var noop = function () {
    return;
};
var togglePlugins = function (client, enabled, plugins) {
    if (!client || !(plugins === null || plugins === void 0 ? void 0 : plugins.length))
        return;
    if (enabled) {
        client.plugins.enable(plugins);
    }
    else {
        client.plugins.disable(plugins, noop);
    }
};
var createClientConsentCallback = function (options) { return function (client) {
    var handler = function (evt) {
        Object.keys(evt.detail).forEach(function (key) {
            var enabled = evt.detail[key] === 'ACCEPT';
            var plugins = options[key];
            togglePlugins(client, enabled, plugins);
        });
    };
    window.addEventListener(ConsentEvent.EVENT_NAME, handler);
}; };
exports.createClientConsentCallback = createClientConsentCallback;
//# sourceMappingURL=createClientConsentCallback.js.map